import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardImage,
  CardTitle,
  Link,
  CardBody,
  CarouselItem,
} from '@lanl-web/lanl-components';

import { getImageUrl } from '../../../../utils';

const Story = ({ index, image, link, title }) => {
  return (
    <CarouselItem className='lanl-card-carousel-item' itemId={index} card>
      <Card>
        <CardImage
          alt={`${title} Image`}
          src={getImageUrl(image?.filename_disk ?? '')}
          link={link}
          className='card-image'
        />
        <CardBody>
          <CardTitle>{title}</CardTitle>
          <Link href={link} className='mt-auto'>
            Read More
            <span className='sr-only'>about the article: {title}</span>
          </Link>
        </CardBody>
      </Card>
    </CarouselItem>
  );
};

Story.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  index: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Story;
